module.exports = __webpack_public_path__ + "weixin/img/card-query.9f05a59e.jpg";